export default "__VITE_ASSET__d6i9DQKt__"